import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import veterinaryCareListAction from './veterinaryCareList.action.json' with { type: 'json' }
import {
  veterinaryCareFilterObject,
  veterinaryCareListItemObject,
} from '../veterinaryCareObject'

export const veterinaryCareExpression = expression(veterinaryCareFilterObject.shape)

const veterinaryCareListDefinition = defineAction({
  ...veterinaryCareListAction,

  input: z.object({
    filter: veterinaryCareExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      serviceDate: 'Data do atendimento',
      closedAt: 'Data de encerramento',
      id: 'Identificador',
      code: 'Codigo',
      veterinarianId: 'Veterinário',
      species: 'Especie',
      type: 'Tipo',
      createdAt: 'Criacao',
      updatedAt: 'Atualização',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(veterinaryCareListItemObject),
    count: z.number(),
  }),
})

export default veterinaryCareListDefinition
